<app-loading *ngIf="contentReady"></app-loading>
<div class="addresses-container bg-light">
  <div class="row d-flex justify-content-center align-items-center" style="margin-bottom: 70px;">

    <div>

      <form class="form address-card" style="margin-top: 10px;" [formGroup]="changePasswordForm"
        (ngSubmit)="onSubmit()">
        <div class="col-12" style="text-align: center;">
          <img style="width: 200px;margin: 0 auto;" src="/assets/e-commerce/icons/51.webp" alt="" />
        </div>
        <h2 class="logintext">{{ "Set New Password" | transloco }}</h2>
        <div class="col-12">
          <label for="old_password">{{
            "Old Password" | transloco
            }}</label>
          <input class="form-control" id="oldPassword" type="{{ isPasswordVisible ? 'text' : 'password' }}"
            formControlName="old_password" placeholder="{{ 'Old Password' | transloco }}" [ngClass]="{
              'is-invalid':
              changePasswordForm.controls['old_password'].touched &&
              changePasswordForm.controls['old_password'].errors,
              'is-valid':
              changePasswordForm.controls['old_password'].touched &&
              changePasswordForm.controls['old_password'].errors == null ,
              'is-touched':
              changePasswordForm.controls['old_password'].untouched &&
              changePasswordForm.controls['old_password'].errors == null,
          }" />
        </div>
        <div class="col-md-12 mb-3">
          <label for="Password">{{
            "Password" | transloco
            }}</label>
          <input class="form-control" id="Password" type="{{ isPasswordVisible ? 'text' : 'password' }}"
            formControlName="new_password" placeholder="{{ 'Password' | transloco }}" [ngClass]="{
              'is-invalid':
              changePasswordForm.controls['new_password'].touched &&
              changePasswordForm.controls['new_password'].errors,
              'is-valid':
              changePasswordForm.controls['new_password'].touched &&
              changePasswordForm.controls['new_password'].errors == null ,
              'is-touched':
              changePasswordForm.controls['new_password'].untouched &&
              changePasswordForm.controls['new_password'].errors == null,
          }" />
        </div>
        <div class="col-md-12 mb-3">
          <label for="confirmPassword">{{
            "Confirm Password" | transloco
            }}</label>
          <input class="form-control" id="confirmPassword" type="{{ isPasswordVisible ? 'text' : 'password' }}"
            formControlName="new_password_confirmation" placeholder="{{ 'Confirm Password' | transloco }}" [ngClass]="{
              'is-invalid':
              changePasswordForm.controls['new_password_confirmation'].touched &&
              changePasswordForm.controls['new_password_confirmation'].errors,
              'is-valid':
              changePasswordForm.controls['new_password_confirmation'].touched &&
              changePasswordForm.controls['new_password_confirmation'].errors == null ,
              'is-touched':
              changePasswordForm.controls['new_password_confirmation'].untouched &&
              changePasswordForm.controls['new_password_confirmation'].errors == null,
          }" />
          <button type="button" class="hidePasswordBtn" (click)="togglePasswordVisibility()">
            @if(!isPasswordVisible){
            {{ "Show Password" | transloco }}
            } @else {
            {{ "Hide Password" | transloco }}
            }
          </button>
        </div>
        <button type="submit" class="submit-btn login">
          {{ "Send" | transloco }}
        </button>
      </form>
    </div>
  </div>
</div>